<template>
  <div class="paragraph-dropdown-container">
    <p v-markdown="paras[0]"></p>
    <vue-select class="paragraph-select" v-model="sortBy" v-bind="optionProps"></vue-select>
    <p v-if="paras[1]" v-markdown="paras[1]"></p>
  </div>
</template>

<script>
import VueSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import {store} from './ExternalComponent/wuhanData'

export default {
  props: ['attributes'],
  components: {VueSelect},
  data () {
    return {
      optionProps: {
        options: [
          {
            label: 'confirmed cases',
            value: 'cases'
          },
          {
            label: 'new cases',
            value: 'new_cases'
          },
          {
            label: 'deaths',
            value: 'deaths'
          }
        ],
        clearable: false,
        searchable: false,
        clearSearchOnSelect: false
      }
    }
  },
  computed: {
    sortBy: {
      get () {
        return store.sortBy
      },
      set (value) {
        store.sortBy = value
      }
    },
    paras () {
      return this.attributes.value.split(/\{\{dropdown\}\}/)
    }
  },
  mounted () {
    this.sortBy = this.optionProps.options[0]
  }
}
</script>

<style lang="scss">
.component.component-pdropdown {
  padding-top: 17px;
  padding-bottom: 17px;

  .paragraph-dropdown-container {
    p {
      display: inline;
    }

    .v-select.paragraph-select {
      display: inline-block;
      vertical-align: middle;
      font-family: $font-CuratorRegular;
      font-size: 16px;
      line-height: 1;
      color: $black;

      .vs__selected-options {
        width: 150px;
      }

      .vs__selected {
        // line-height: 1;
      }
    }
  }
}
</style>
